import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/book";
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="scroll-mt-20 bg-ink py-24 lg:py-32" data-id="element-39" data-mp="1hdun8f7zex85">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[0.8fr_1.2fr] lg:px-10" data-id="element-40" data-mp="1cfjb1xu7samr">
        <div data-id="element-41" data-mp="2a178mm2eoyzv">
          <h2 className="font-display text-4xl text-cream sm:text-5xl" data-id="element-42" data-mp="2a0xeqne8q7ow">Questions</h2>
          
        </div>

        <div className="border-t border-line" data-id="element-43" data-mp="253p19041ertz">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          return <div key={faq.question} className="border-b border-line" data-id="element-44" data-mp="205vqdtrsh9nd" data-mpi={i}>
                <h3 data-id="element-45" data-mp="1v4pz80ds1ufy">
                  <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-semibold text-cream transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-46" data-mp="1v7c39q1glrtf">
                    {faq.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${open ? "rotate-45" : ""}`} data-id="element-47" data-mp="1pls0lzmnrbcb" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-48" data-mp="1fnuf3jw6nsne">
                  {open && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-49" data-mp="1fqgkpdzijy2z">
                      <p className="pb-6 pr-10 leading-relaxed text-muted" data-id="element-50" data-mp="iy4m0j3gbiw9">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}